/**!
 * Swiper 11.1.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 9, 2024
 */
import swiper from "./modules/swiper/swiper";
swiper();

/**
 * YoutubePlayerApi / Vanilla Js
 */
import "./modules/youtube_player_api/_base.scss";
import "./modules/youtube_player_api/_style.scss";
import YoutubePlayerApi from "./modules/youtube_player_api/youtube_player_api";
YoutubePlayerApi();
